import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

/**
 ******************************
 * @API
 ******************************
 */

export async function sendCode({ phone }) {
    await axios.post(`${API_URL}public/`, {
        method: 'Auth.sendCode',
        params: {
            phone,
        },
    })
}

export async function signIn({ phone, code }) {
    let response

    try {
        response = await axios.post(`${API_URL}public/`, {
            method: 'Auth.authorize',
            params: {
                phone,
                code,
            },
        })
    } catch (error) {
        return Promise.reject(error)
    }

    return response?.data?.response
}
